module.exports = __webpack_public_path__ + "static/media/the-massive-farms-emerging-beneath-our-cities_twitter_image.83b86b60.jpg";